import { createAsyncThunk } from '@reduxjs/toolkit';

import * as logs from 'endpoints/error-logs';
import { ApiResponse } from 'endpoints/endpoint';
import { apiRequest } from 'client/utils';

export const sendErrorReport = createAsyncThunk<
  ApiResponse<logs.SendErrorReportResult, logs.SendErrorReportError>,
  logs.SendErrorReportParams,
  { rejectValue: string }
>('logs/sendErrorReport', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest<
      logs.SendErrorReportParams,
      logs.SendErrorReportResult,
      logs.SendErrorReportError
    >(logs.sendErrorReport, {
      retries: true,
      data,
    })();

    if (response.success) {
      return response;
    }

    throw new Error('SendErrorReportError');
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
